'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var IndustryCard = require('./IndustryCard.js');
var OtherIndustrySelect = require('./OtherIndustrySelect.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var HvacIcon = require('../../images/Onboarding/IndustrySelection/HvacIcon.js');
var CarpetIcon = require('../../images/Onboarding/IndustrySelection/CarpetIcon.js');
var MaidIcon = require('../../images/Onboarding/IndustrySelection/MaidIcon.js');
var PlumbingIcon = require('../../images/Onboarding/IndustrySelection/PlumbingIcon.js');
var ElectricalIcon = require('../../images/Onboarding/IndustrySelection/ElectricalIcon.js');
var GarageIcon = require('../../images/Onboarding/IndustrySelection/GarageIcon.js');
var HandymanIcon = require('../../images/Onboarding/IndustrySelection/HandymanIcon.js');
var WindowIcon = require('../../images/Onboarding/IndustrySelection/WindowIcon.js');
var LandscapingIcon = require('../../images/Onboarding/IndustrySelection/LandscapingIcon.js');
var AppliancesIcon = require('../../images/Onboarding/IndustrySelection/AppliancesIcon.js');
var AutomotiveIcon = require('../../images/Onboarding/IndustrySelection/AutomotiveIcon.js');
var VentsIcon = require('../../images/Onboarding/IndustrySelection/VentsIcon.js');
var GeneralIcon = require('../../images/Onboarding/IndustrySelection/GeneralIcon.js');
var PestIcon = require('../../images/Onboarding/IndustrySelection/PestIcon.js');
var FleetIcon = require('../../images/Onboarding/IndustrySelection/FleetIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var icons = {
  HVAC: React__default["default"].createElement(HvacIcon, null),
  CARPET: React__default["default"].createElement(CarpetIcon, null),
  MAID: React__default["default"].createElement(MaidIcon, null),
  PLUMBING: React__default["default"].createElement(PlumbingIcon, null),
  ELECTRICAL: React__default["default"].createElement(ElectricalIcon, null),
  GARAGE: React__default["default"].createElement(GarageIcon, null),
  HANDYMAN: React__default["default"].createElement(HandymanIcon, null),
  EXTERIOR: React__default["default"].createElement(WindowIcon, null),
  LANDSCAPING: React__default["default"].createElement(LandscapingIcon, null),
  APPLIANCES: React__default["default"].createElement(AppliancesIcon, null),
  AUTOMOTIVE: React__default["default"].createElement(AutomotiveIcon, null),
  AIR_DUCT: React__default["default"].createElement(VentsIcon, null),
  GENERAL_CONTRACTOR: React__default["default"].createElement(GeneralIcon, null),
  PEST: React__default["default"].createElement(PestIcon, null),
  OTHER: React__default["default"].createElement(FleetIcon, null)
};

var IndustrySelection =
/*#__PURE__*/
function (_PureComponent) {
  inherits(IndustrySelection, _PureComponent);

  function IndustrySelection(props) {
    var _this;

    classCallCheck(this, IndustrySelection);

    _this = possibleConstructorReturn(this, getPrototypeOf(IndustrySelection).call(this, props));
    var showOtherIndustries = props.other_service_categories.find(function (industry) {
      return industry.id === props.selectedIndustry.id;
    });
    _this.state = {
      showOtherIndustries: showOtherIndustries,
      selectOpen: false
    };
    return _this;
  }

  createClass(IndustrySelection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          popular_service_categories = _this$props.popular_service_categories,
          other_service_categories = _this$props.other_service_categories,
          selectedIndustry = _this$props.selectedIndustry,
          onIndustrySelected = _this$props.onIndustrySelected,
          onOtherSelected = _this$props.onOtherSelected;
      return React__default["default"].createElement(Grid, {
        container: true,
        spacing: 24,
        alignItems: "center",
        justify: "center"
      }, popular_service_categories.map(function (industry, index) {
        return React__default["default"].createElement(Grid, {
          item: true,
          key: index
        }, React__default["default"].createElement(IndustryCard, {
          name: industry.name,
          icon: icons[industry.asset_id],
          industry: industry,
          onClick: function onClick(industry) {
            onIndustrySelected(industry);

            _this2.setState({
              showOtherIndustries: false
            });
          },
          isSelected: industry.id === selectedIndustry.id
        }));
      }), React__default["default"].createElement(Grid, {
        item: true
      }, React__default["default"].createElement(IndustryCard, {
        name: 'Other',
        icon: icons['OTHER'],
        onClick: function onClick() {
          _this2.setState({
            showOtherIndustries: true,
            selectOpen: true
          });

          onOtherSelected();
        },
        isSelected: this.state.showOtherIndustries
      })), this.state.showOtherIndustries && React__default["default"].createElement(Grid, {
        container: true,
        justify: "center"
      }, React__default["default"].createElement(Grid, {
        item: true,
        xs: 10,
        sm: 8,
        m: 6
      }, React__default["default"].createElement(OtherIndustrySelect, {
        other_service_categories: other_service_categories,
        selectedIndustry: selectedIndustry,
        onIndustrySelected: onIndustrySelected,
        selectOpen: this.state.selectOpen,
        onSelectClose: function onSelectClose() {
          return _this2.setState({
            selectOpen: false,
            showOtherIndustries: ObjectHelper.isPresent(other_service_categories.find(function (industry) {
              return industry.id === selectedIndustry.id;
            }))
          });
        },
        onSelectOpen: function onSelectOpen() {
          return _this2.setState({
            selectOpen: true
          });
        }
      }))));
    }
  }]);

  return IndustrySelection;
}(React.PureComponent);
IndustrySelection.defaultProps = {
  popular_service_categories: [],
  other_service_categories: [],
  onIndustrySelected: function onIndustrySelected() {},
  selectedIndustry: {},
  onOtherSelected: function onOtherSelected() {}
};

exports["default"] = IndustrySelection;
exports.icons = icons;
